import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import TransactionsView from 'components/composed/views/TransactionsView';

const StyledContainer = styled.div`
  @media ${theme.devices.tablet} {
  }
`;

const TransactionsSection = () => {
  return (
    <StyledContainer>
      <TransactionsView />
    </StyledContainer>
  );
};

export default TransactionsSection;
